import React, { useState } from 'react';
import { CompactGlossaryList } from '../../components/glossary/CompactGlossaryList';
import { TooltipGlossaryList } from '../../components/glossary/TooltipGlossaryList';
import { GlossaryList } from '../../components/glossary/GlossaryList';
import { LayoutSelector, LayoutMode } from '../../components/glossary/LayoutSelector';

/**
 * Main dashboard page for the Glossary app with layout switching
 */
const GlossaryDashboard: React.FC = () => {
  const [layoutMode, setLayoutMode] = useState<LayoutMode>('tooltip');

  const renderGlossaryComponent = () => {
    switch (layoutMode) {
      case 'compact':
        return <CompactGlossaryList />;
      case 'tooltip':
        return <TooltipGlossaryList />;
      case 'expanded':
        return <GlossaryList />;
      default:
        return <CompactGlossaryList />;
    }
  };

  return (
    <div>
      {/* Layout Selector */}
      <div className="p-4 md:p-8 pb-0">
        <div className="flex justify-between items-center mb-0">
          <div>
            <h1 className="text-3xl font-bold" style={{ color: 'var(--glossary-heading-text)' }}>
              Glossary Dashboard
            </h1>
            <p className="text-gray-400 mt-1">Choose your preferred view mode</p>
          </div>
          <LayoutSelector
            currentLayout={layoutMode}
            onLayoutChange={setLayoutMode}
          />
        </div>
      </div>

      {/* Dynamic Glossary Component */}
      <div>
        {renderGlossaryComponent()}
      </div>
    </div>
  );
};

export default GlossaryDashboard;